  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5"  v-role="'func'">
    <v-btn  class="mx-2" fab dark color="primary" @click="$router.push('menu-estatistica')">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
     <div class="text-center">
      <v-progress-circular v-if="progresso"
      indeterminate
      color="primary"
    >Aguarde...</v-progress-circular>

   </div>
    <v-row no-gutters>
      <v-col cols="12" md="1" >
         </v-col>
       <v-col cols="12" md="2" >
          </v-col>
           <v-col cols="12" md="9">
      <input type="radio" name="gender" v-model="row" value="1"> Área
  <input type="radio" name="gender" v-model="row" value="2"> Barras
  <input type="radio" name="gender" v-model="row" value="3"> Pie
  <input type="radio" name="gender" v-model="row" value="4"> Radar
  <input type="radio" name="gender" v-model="row" value="5"> Line
            </v-col>
    </v-row>

<v-row>
        <v-col >

      <div class="container">
   <Doughnut
      v-if="loaded && row==='1'"
      :chartdata="chartdata"
      :options="options"/>

       <Bar
      v-if="loaded && row==='2'"
      :chartdata="chartdata"
      :options="options"/>

       <Pie
      v-if="loaded && row==='3'"
      :chartdata="chartdata"
      :options="options"/>

       <Radar
      v-if="loaded && row==='4'"
      :chartdata="chartdata"
      :options="options"/>

       <LineChart
      v-if="loaded && row==='5'"
      :chartdata="chartdata"
      :options="options"/>

  </div>

      </v-col>

    </v-row>
  </v-container>
  </template>

 </div>
</template>

<script>
import axios from '../../../plugins/axios'
export default {
  name: 'BarChartContainer',
  components: {
    Doughnut: () => import('../../../components/Area.vue'),
    Bar: () => import('../../../components/Bar.vue'),
    LineChart: () => import('../../../components/Chart.vue'),
    Radar: () => import('../../../components/Radar.vue'),
    Pie: () => import('../../../components/Pie.vue')
  },
  data: () => ({
    row: null,
    loaded: false,
    progresso: false,
    isUpdating: false,
    anoLectivos: [],
    quant: [],
    quantAlunosInstituicao: [],
    chartdata: {
      labels: [],
      datasets: [
        {
          label: 'Quantidade de alunos no ano lectivo',
          backgroundColor: ['rgba(255, 99, 71, 0.8)', 'rgb(60, 179, 113)', 'rgb(0, 0, 255)', 'rgb(255, 165, 0)', 'rgb(0, 0, 0)', 'rgb(238, 130, 238)'],
          data: []
        }
      ]
    },

    options: {
      responsive: true,
      legend: {
        display: true,
        position: 'top',
        labels: {
          fontColor: 'rgba(255, 99, 71, 0.8)'
        }
      },
      maintainAspectRatio: false
    }
  }),
  created  () {
    this.quantAlunoInstituicao()
  },
  async mounted () {
    this.loaded = false
    try {
      //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },
  methods: {

    async quantAlunoInstituicao () {
      this.progresso = true

      try {
        this.quantAlunosInstituicao = await axios
          .get('/quantidadeAlunosInstituicao')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      } this.filterQuantAlunosInstituicao()
    },

    filterQuantAlunosInstituicao () {
      for (let index = 0; index < this.quantAlunosInstituicao.length; index++) {
        this.anoLectivos[index] = (this.quantAlunosInstituicao[index].anoLectivo)
        this.quant[index] = (this.quantAlunosInstituicao[index].quantidade)
      }
      this.chartdata.labels = this.anoLectivos
      this.chartdata.datasets[0].data = this.quant
      this.loaded = false
      this.$nextTick(() => {
        this.row = '1'
        this.loaded = true
      })
    }

  }
}

</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
